export default __webpack_public_path__ + "locales/bg/FilesSettings.json?hash=d5b306e3e3785c05f4909a91358879d0";